var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ticket_closed",
    "data-name": "Ticket closed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.394,
    height: 22.394,
    viewBox: "0 0 22.394 22.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4481",
    "data-name": "Ellipse 4481",
    cx: 9.025,
    cy: 9.025,
    r: 9.025,
    transform: "translate(3.008 2.172)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M13.546,20.292l7.922-7.922L20.18,11.11l-6.634,6.634-3.359-3.359-1.26,1.26Zm1.652,6.1a10.834,10.834,0,0,1-4.339-.882,11.281,11.281,0,0,1-5.976-5.976,11.185,11.185,0,0,1,0-8.706A11.19,11.19,0,0,1,7.289,7.275a11.478,11.478,0,0,1,3.569-2.393,11.185,11.185,0,0,1,8.706,0,11.18,11.18,0,0,1,5.948,5.948,11.185,11.185,0,0,1,0,8.706,11.478,11.478,0,0,1-2.393,3.569,11.19,11.19,0,0,1-3.555,2.407A10.9,10.9,0,0,1,15.2,26.394Z",
    transform: "translate(-4 -4)",
    fill: "#b7cdd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketClosed);
export default __webpack_public_path__ + "static/media/ticket_closed.ecccf1baa88e52edebe4112c84f5b855.svg";
export { ForwardRef as ReactComponent };